import clsx from 'clsx'
import { Col, Grid, Row } from 'gu-ui-kit'
import { decode } from 'js-base64'
import styles from 'modules/Agency/AddClient/add-client.module.scss'
import formStyles from 'modules/Forms/common-form.module.scss'
import StatisticsAccountConnectForm from 'modules/Forms/Statistics/AccountConnect'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { search } from 'utils/hooks/useLocationFilters'
import NETWORK_PREFIX_MAP from 'modules/Statistics/networkPrefixMap'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { ROUTES } from 'constants/routes'
import { notificationShow } from 'modules/Notifications/actions'

const AccountConnect = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation()
  const pathGen = useGeneratePathI18n()

  const { account_data, adv_type, adv_account_id } = search(global.location)
  const [accountData, setAccountData] = useState(null)

  const { hierarchy } = useSelector((state) => ({
    hierarchy: state['statistics/accountConnect'].hierarchy,
  }))

  useEffect(() => {
    if (account_data) {
      setAccountData(JSON.parse(decode(account_data)))
    } else {
      dispatch(
        notificationShow({
          type: 'error',
          message: 'common::notifications.data_fetch_failed',
        }),
      )
    }
  }, [])

  useEffect(() => {
    !!accountData &&
      dispatch({
        type: 'STATISTICS/PROFILES_HIERARCHY_FETCH',
        payload: { external_id: accountData.external_id },
      })
  }, [accountData])

  return (
    <Grid>
      <Row justifyContent="center">
        <Col s="auto" xs="auto" sm="auto">
          <h1 className={clsx(formStyles.formHeader, styles.header)}>
            {t('statistics::navigation.account_connect')}
          </h1>
          <StatisticsAccountConnectForm
            hierarchy={hierarchy}
            onSubmit={(values) =>
              dispatch({
                type: 'STATISTICS/ACCOUNT_ADD',
                payload: {
                  id: adv_account_id,
                  network: NETWORK_PREFIX_MAP[adv_type],
                  data: { google_analytics_profile_id: values.id },
                },
              })
            }
            onSubmitSuccess={() => {
              if (global.opener) {
                global.opener.postMessage(
                  'accountAddSuccess',
                  window.location.origin,
                )
              } else {
                history.push(pathGen(ROUTES.STATISTICS))
              }
            }}
            onGoBack={() => {
              if (global.opener) {
                global.opener.postMessage(
                  'accountGoBackConnection',
                  window.location.origin,
                )
              } else {
                history.push(pathGen(ROUTES.STATISTICS))
              }
            }}
          />
        </Col>
      </Row>
    </Grid>
  )
}

export default AccountConnect
